export const CHALLENGE_PAGE_POSTHOG_VARIANTS = ['control', 'test', 'clarity'] as const;
export type ChallengePagePostHogVariant = (typeof CHALLENGE_PAGE_POSTHOG_VARIANTS)[number];

export const CHALLENGE_PAGE_EXPERIMENT = {
  name: 'challenge_page_control_refined_clarity_2026_08_31',
  featureFlag: 'challenge-page-control-refined-clarity-2026-08-31',
  posthogExperimentId: 459166,
  predecessorPosthogExperimentId: 445170,
  status: 'active',
  posthogVariants: CHALLENGE_PAGE_POSTHOG_VARIANTS,
  variants: {
    control: 'Current challenge page',
    test: 'Refined challenge page',
    clarity: 'Clarity-painted refined challenge page',
  },
  primaryMetric: 'Confirmed challenge registration conversion',
  secondaryMetrics: ['Challenge form submission conversion'],
} as const;
